import { toErrorMessage } from './safeStr';

/** HTTP status from an Axios-style API error, when available. */
export function apiErrorStatus(error: unknown): number | null {
    const status = (error as any)?.response?.status;
    return typeof status === 'number' ? status : null;
}

/** 401 handling belongs to the global API interceptor, which redirects to login. */
export function isAuthenticationError(error: unknown): boolean {
    return apiErrorStatus(error) === 401;
}

/** 403: authenticated but not a collaborator on this case/investigation. */
export function isAuthorizationError(error: unknown): boolean {
    return apiErrorStatus(error) === 403;
}

/** Officer-facing case creation failure with an actionable retry instruction. */
export function caseCreationErrorMessage(error: unknown): string {
    const status = apiErrorStatus(error);

    if (status === 403) {
        return 'You do not have permission to create cases. Select an existing case or contact an administrator.';
    }
    if (status === 409) {
        return 'A case with these details already exists. Select it from the case list.';
    }
    if (status != null && status >= 500) {
        return 'The case service is temporarily unavailable. Your analysis is preserved; retry or select an existing case.';
    }

    const detail = toErrorMessage(error, 'Unable to create the case.');
    return `${detail} Your analysis is preserved; retry or select an existing case.`;
}
